// import { TooltipButton } from '@/components/ui/TooltipButton'
import { cn } from '@/lib/utils'
import clsx from 'clsx'
import { useState } from 'react'

interface ComponentTitleProps {
  title?: React.ReactNode
  description?: string
  className?: string
}

export function ComponentTitle({ title, description, className }: ComponentTitleProps) {
  const [truncateDescription, setTruncateDescription] = useState(true)
  if (!title) return null

  return (
    <div className={cn('flex flex-col gap-y-2', className)}>
      {typeof title === 'string' ? <h2 className="line-clamp-1 text-lg">{title}</h2> : title}
      {/* <p
        className={clsx('text-xs', { 'line-clamp-1': truncateDescription })}
        onMouseEnter={() => setTruncateDescription(false)}
        onMouseLeave={() => setTruncateDescription(true)}
      >
        {description}
      </p> */}
      <p
        className={clsx('text-xs', { 'line-clamp-1': truncateDescription })}
        role="button"
        tabIndex={0}
        onClick={() => setTruncateDescription((current) => !current)}
      >
        {description}
      </p>
      {/* {description && (
        <TooltipButton tooltip={description}>
          <p className="line-clamp-1 text-xs">{description}</p>
        </TooltipButton>
      )} */}
    </div>
  )
}
